import { render } from "./CoinsView.vue?vue&type=template&id=2859ecc6&scoped=true&lang=pug"
import script from "./CoinsView.vue?vue&type=script&lang=js"
export * from "./CoinsView.vue?vue&type=script&lang=js"

import "./CoinsView.vue?vue&type=style&index=0&id=2859ecc6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\freemath\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2859ecc6"]])

export default __exports__